import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { TdDialogService } from '@covalent/core';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { PrintingService } from '../../../../shared/services/printing.service';
import { LocationService } from 'services/location.service';

@Component({
  selector: 'app-print-location-label',
  templateUrl: './print-location-label.component.html',
  styleUrls: ['./print-location-label.component.scss'],
  providers: [PrintingService]
})
export class PrintLocationLabelComponent implements OnInit {
  locationToPrint: string;

  locations: any[] = [];


  constructor(private _dialogService: TdDialogService,
    private _location: Location,
    private _locationService: LocationService,
    public _authService: AuthenticationService,
    private _printService: PrintingService,
  ) { }

  ngOnInit() {
    this.getLocations();
  }

  getLocations() {
    this._locationService.getLocations(this._authService.getHomeBranch() + '').subscribe(
      response => {
        this.locations = response;
      }
    );
  }

  print() {
    // If location is not in the list
    if (this.locations.find((l) => { return l.name == this.locationToPrint }) == null) {
      this._dialogService.openAlert({
        title: 'Invalid Location',
        message: 'The location that you scanned is not registered in your home branch'
      });
      return;
    }

    this._printService.print({ location: this.locationToPrint }, this._authService.getPrinterId(), 1, 'location').subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this._dialogService.openAlert({
            message: 'Sent to print queue!',
            title: 'Success'
          });
        } else {
          this._dialogService.openAlert({
            message: 'Could not send to print queue!',
            title: 'Failed'
          });
        }
      }
    );
  }

  goBack(): void {
    this._location.back();
  }

}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/pda/inventory/print-location-label/print-location-label.component.ts